<template>
  <div class="qf-table-header">
    <div class="qf-table-fixed-left" ref="fixedLeftRef" v-if="colLeft?.length || checkedParams.enabled || expandIcon || cornerMark || rowDragParams.enabled" :class="{ 'header-cell-active': dragActive, 'scroll-left-shadow': scrollShadowLeft, 'non-left-fixed': colLeft?.length === 0 }">
      <div class="corner-mark" v-if="cornerMark"></div>
      <div v-if="isGroup" :style="{ width: (isGroup - 1) * 12 + 'px' }"></div>
      <div class="qf-table-drag-box" @click.stop v-if="rowDragParams.enabled && isGroup === 0" :class="{ 'qf-table-header-fixed-left-last': colLeft?.length === 0 && !checkedParams.enabled && !expandIcon }"></div>
      <div class="qf-table-expand-box" @click.stop v-if="expandIcon && isGroup === 0" :class="{ 'qf-table-header-fixed-left-last': colLeft?.length === 0 && !checkedParams.enabled }"></div>
      <div class="qf-table-header-checkbox" :class="{ 'qf-table-header-fixed-left-last': colLeft?.length === 0 }" :style="{ width: checkedParams.width + 'px' }" @click.stop="" v-if="checkedParams.enabled">
        <slot name="customTitleCheckbox" :change="handleChangeAll" :indeterminate="indeterminate">
          <jw-checkbox :model-value="checkedAll" :indeterminate="indeterminate" @change="handleChangeAll"></jw-checkbox>
        </slot>
      </div>
      <slot name="placeholderElement"></slot>
      <div v-for="(col, index) in colLeft" :key="col.colKey" class="qf-table-header-cell" :style="{ width: col.width + 'px' }" @mouseover="hoverColumn(col.colKey)" @mouseleave="leaveColumn" :class="{ 'qf-table-header-fixed-left-last': index === colLeft.length - 1 }">
        <div class="qf-table-header-container">
          <template v-if="col.headerRender">
            <component :is="col.headerRender(h, col)" />
          </template>
          <template v-else-if="col.headerSlotName">
            <slot :name="col.headerSlotName" :col="col"></slot>
          </template>
          <template v-else>
            <span class="qf-table-header-prefix" v-if="slots.prefix"><slot name="prefix" :col="col"></slot></span>
            <span class="qf-table-header-text" :style="{ width: filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean' ? 'calc(100% - 22px)' : '100%' }">
              <qf-ellipsis :content="col.title" />
              <jw-tooltip v-if="col.description" :content="col.description">
                <icon-question-circle class="tip-icon" />
              </jw-tooltip>
            </span>
            <span class="qf-table-header-icon-extra" v-if="slots.extraHeader && (filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean')" @click="headerIconMore($event, col, false, `${index}-${index}`)">
              <slot name="extraHeader" :colKey="col.colKey" :index="index" :sort="col.fieldSort"> </slot>
            </span>
            <template v-else>
              <span v-if="col.iconMore && activeFieldKey === col.colKey" class="qf-table-header-icon-more" @click="headerIconMore($event, col, false, `${index}-${index}`)">
                <slot name="iconMore" :colKey="col.colKey">
                  <icon-more />
                </slot>
              </span>
            </template>
          </template>
        </div>
        <div :class="{ 'drag-handle-right': true, 'drag-handle-right-active': dragActive }" @mousedown="handleMouseDown($event, col)"></div>
      </div>
    </div>
    <div class="qf-table-content" v-if="colMiddle?.length" :class="{ 'header-cell-active': dragActive }">
      <div v-for="(col, index) in colMiddle" :key="col.colKey" class="qf-table-header-cell-container">
        <template v-if="col.children">
          <div class="qf-table-header-sub-form">
            <div class="qf-table-header-sub-form-title" :style="{ width: col.width + 'px' }">
              <span class="qf-table-header-prefix" v-if="slots.prefix"><slot name="prefix" :col="col"></slot></span>
              <span class="qf-table-header-sub-form-title-text">
                <qf-ellipsis :content="col.title" />
              </span>
            </div>
            <div style="display: flex" class="qf-table-header-sub-form-container">
              <template v-for="(child, childIndex) in col.children" :key="childIndex">
                <div class="qf-table-header-cell" :style="{ width: child.width + 'px' }" @mouseover="hoverColumn(child.colKey)" @mouseleave="leaveColumn">
                  <div class="qf-table-header-container">
                    <template v-if="child.headerRender">
                      <component :is="child.headerRender(h, child)" />
                    </template>
                    <template v-else-if="child.headerSlotName">
                      <slot :name="child.headerSlotName" :col="child"></slot>
                    </template>
                    <template v-else>
                      <span class="qf-table-header-prefix" v-if="slots.prefix"><slot name="prefix" :col="child"></slot></span>
                      <span class="qf-table-header-text" :style="{ width: filterFieldArray.includes(child.colKey) ? 'calc(100% - 22px)' : '100%' }">
                        <qf-ellipsis :content="child.title" />
                        <jw-tooltip v-if="col.description" :content="col.description">
                          <icon-question-circle class="tip-icon" />
                        </jw-tooltip>
                      </span>
                      <span class="qf-table-header-icon-extra" v-if="slots.extraHeader && filterFieldArray.includes(child.colKey)" @click="headerIconMore($event, child, true, `${colLeft?.length + index}-${childIndex}`)">
                        <slot name="extraHeader" :colKey="child.colKey" :index="index" :sort="col.fieldSort"></slot>
                      </span>
                      <template v-else>
                        <span v-if="child.iconMore && activeFieldKey === child.colKey" class="qf-table-header-icon-more" @click="headerIconMore($event, child, true, `${colLeft?.length + index}-${childIndex}`)">
                          <slot name="iconMore" :colKey="child.colKey">
                            <icon-more />
                          </slot>
                        </span>
                      </template>
                    </template>
                  </div>
                  <div :class="{ 'drag-handle-right': true, 'drag-handle-right-active': dragActive }" @mousedown="handleMouseDown($event, child)"></div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="qf-table-header-cell" :style="{ width: col.width + 'px' }" @mouseover="hoverColumn(col.colKey)" @mouseleave="leaveColumn">
            <div class="qf-table-header-container">
              <template v-if="col.headerRender">
                <component :is="col.headerRender(h, col)" />
              </template>
              <template v-else-if="col.headerSlotName">
                <slot :name="col.headerSlotName" :col="col"></slot>
              </template>
              <template v-else>
                <span class="qf-table-header-prefix" v-if="slots.prefix"><slot name="prefix" :col="col"></slot></span>
                <span class="qf-table-header-text" :style="{ width: filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean' ? 'calc(100% - 22px)' : '100%' }">
                  <qf-ellipsis :content="col.title" />
                  <jw-tooltip v-if="col.description" :content="col.description">
                    <icon-question-circle class="tip-icon" />
                  </jw-tooltip>
                </span>
                <span class="qf-table-header-icon-extra" v-if="slots.extraHeader && (filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean')" @click="headerIconMore($event, col, false, `${colLeft?.length + index}-${colLeft?.length + index}`)">
                  <slot name="extraHeader" :colKey="col.colKey" :index="index" :sort="col.fieldSort"> </slot>
                </span>
                <template v-else>
                  <span v-if="col.iconMore && activeFieldKey === col.colKey" class="qf-table-header-icon-more" @click="headerIconMore($event, col, false, `${colLeft?.length + index}-${colLeft?.length + index}`)">
                    <slot name="iconMore" :colKey="col.colKey">
                      <icon-more />
                    </slot>
                  </span>
                </template>
              </template>
            </div>
            <div :class="{ 'drag-handle-right': true, 'drag-handle-right-active': dragActive }" @mousedown="handleMouseDown($event, col)"></div>
          </div>
        </template>
      </div>
    </div>
    <div class="qf-table-fixed-right" v-if="colRight?.length" :class="{ 'header-cell-active': dragActive, 'scroll-right-shadow': scrollShadowRight }">
      <div v-for="(col, index) in colRight" :key="col.colKey" class="qf-table-header-cell" :style="{ width: col.width + 'px' }" @mouseover="hoverColumn(col.colKey)" @mouseleave="leaveColumn">
        <div :class="{ 'drag-handle-left': true, 'drag-handle-left-active': dragActive }" @mousedown="handleMouseDown($event, col)"></div>
        <div class="qf-table-header-container">
          <template v-if="col.headerRender">
            <component :is="col.headerRender(h, col)" />
          </template>
          <template v-else-if="col.headerSlotName">
            <slot :name="col.headerSlotName" :col="col"></slot>
          </template>
          <template v-else>
            <!-- {{slots.prefix({ col })}} -->
            <span class="qf-table-header-prefix" v-if="slots.prefix"><slot name="prefix" :col="col"></slot></span>
            <span class="qf-table-header-text" :style="{ width: filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean' ? 'calc(100% - 22px)' : '100%' }">
              <qf-ellipsis :content="col.title" />
              <jw-tooltip v-if="col.description" :content="col.description">
                <icon-question-circle class="tip-icon" />
              </jw-tooltip>
            </span>
            <span class="qf-table-header-icon-extra" v-if="slots.extraHeader && (filterFieldArray.includes(col.colKey) || typeof col.fieldSort === 'boolean')" @click="headerIconMore($event, col, false, `${colLeft?.length + colMiddle?.length + index}-${colLeft?.length + colMiddle?.length + index}`)">
              <slot name="extraHeader" :colKey="col.colKey" :index="index" :sort="col.fieldSort"> </slot>
            </span>
            <template v-else>
              <span v-if="col.iconMore && activeFieldKey === col.colKey" class="qf-table-header-icon-more" @click="headerIconMore($event, col, false, `${colLeft?.length + colMiddle?.length + index}-${colLeft?.length + colMiddle?.length + index}`)">
                <slot name="iconMore" :colKey="col.colKey">
                  <icon-more />
                </slot>
              </span>
            </template>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, inject, useSlots, onUnmounted } from 'vue';
import QfEllipsis from '../qf-ellipsis/qf-ellipsis.vue';

const props = defineProps({
  columns: {
    type: Array,
    default: () => []
  },
  expandIcon: {
    type: [Boolean, String],
    default: false
  },
  checkedParams: {
    type: Object,
    default: () => ({
      enabled: true,
      type: 'checkbox',
      width: 40
    })
  },
  checkedAll: {
    type: Boolean,
    default: false
  },
  indeterminate: {
    type: Boolean,
    default: false
  },
  showColOverlay: {
    type: Boolean,
    default: false
  },
  filterFieldArray: {
    type: Array,
    default: () => []
  },
  isGroup: {
    type: Number,
    default: 0
  },
  cornerMark: {
    type: Boolean,
    default: true
  }
});

const rowDragParams = inject('qfTable')?.rowDragParams;
const fixedLeftRef = ref(null);
// 插槽集合
const slots = useSlots();
const emits = defineEmits(['startResize', 'handleChangeAll', 'headerIconMore']);
const scrollShadowLeft = ref(inject('qfTable')?.scrollShadowLeft);
const scrollShadowRight = ref(inject('qfTable')?.scrollShadowRight);

// 全选
const handleChangeAll = (val) => {
  console.log(602, '全选', val);
  emits('handleChangeAll', val);
};
const activeFieldKey = ref(null);
const clickIconMore = ref(false);
const hoverColumn = (key) => {
  activeFieldKey.value = key;
};
const dragActive = ref(false); //拖拽激活
const leaveColumn = () => {
  if (!clickIconMore.value) {
    activeFieldKey.value = null;
  }
};
// 点击头部更多
const headerIconMore = (e, col, isSubForm, position) => {
  // console.log(602, '点击头部更多', e, col, isSubForm);
  clickIconMore.value = true;
  emits('headerIconMore', { e, col, isSubForm, position });
};
const stopShowColWatch = watch(
  () => props.showColOverlay,
  (v) => {
    if (!v) {
      activeFieldKey.value = null;
      clickIconMore.value = false;
    }
  }
);
const colLeft = computed(() => props.columns?.filter((v) => v.fixed === 'left'));
const colMiddle = computed(() => props.columns?.filter((v) => v.fixed !== 'left' && v.fixed !== 'right'));
const colRight = computed(() => props.columns?.filter((v) => v.fixed === 'right'));

// 拖拽相关
const handleMouseDown = (e, col) => {
  e.stopPropagation();
  const rect = e.currentTarget?.getBoundingClientRect();
  console.log(145, e, col, rect);
  dragActive.value = true;
  emits('startResize', e, col, rect.left - col.width);
};
const handleMouseUp = () => {
  dragActive.value = false;
};
const getFixedLeftWidth = () => {
  if (!fixedLeftRef.value) return 0;
  return colLeft.value?.reduce((acc, cur) => acc - cur.width, fixedLeftRef.value.getBoundingClientRect().width) || 0;
};
defineExpose({
  handleMouseUp,
  getFixedLeftWidth
});
onUnmounted(() => {
  stopShowColWatch();
});
</script>
<style scoped lang="less">
@import './qf-table-header.less';
</style>
